import {Component, Inject} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-confirm',
    templateUrl: './confirm.component.html',
    styleUrls: ['./confirm.component.scss'],
    standalone: true,
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton, TranslateModule]
})
export class ConfirmComponent {
  get content(): string {
    return this.data.content;
  }

  get title(): string | undefined {
    return this.data.title;
  }

  constructor(
    private dialogRef: MatDialogRef<ConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { content: string, title?: string }
  ) {
  }

  cancel() {
    this.dialogRef.close({ confirmed: false });
  }

  confirm() {
    this.dialogRef.close({ confirmed: true });
  }

}

export interface ConfirmResult {
  confirmed: boolean;
}
